import { render, staticRenderFns } from "./JCHomeIndex.vue?vue&type=template&id=c5728c56&scoped=true&"
import script from "./JCHomeIndex.vue?vue&type=script&lang=js&"
export * from "./JCHomeIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5728c56",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c5728c56')) {
      api.createRecord('c5728c56', component.options)
    } else {
      api.reload('c5728c56', component.options)
    }
    module.hot.accept("./JCHomeIndex.vue?vue&type=template&id=c5728c56&scoped=true&", function () {
      api.rerender('c5728c56', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/JCHomeIndex.vue"
export default component.exports